export const SET_FEED_VIEW = "feed/SET_FEED_VIEW";
export const SET_FEED_ITEM_ORDER = "feed/SET_FEED_ITEM_ORDER";
export const FEED_EXPLORE_SET = "feed/FEED_EXPLORE_SET";
export const FEED_EXPLORE_RESET = "feed/FEED_EXPLORE_RESET";
export const FEED_OPTIMISTIC_LIKE_POST = "feed/OPTIMISTIC_LIKE_POST";
export const FEED_MERGE_POST_PARTIAL = "feed/MERGE_POST_PARTIAL";
export const FEED_PREPEND_POST = "feed/PREPEND_POST";
export const FEED_MERGE_POSTS_COMMENTS = "feed/MERGE_POSTS_COMMENTS";
